// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          value: undefined,
          domains: /* [] */0
        };
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function domains(t) {
  return t.domains;
}

function setDomains(t, domains) {
  return {
          id: t.id,
          value: t.value,
          domains: domains
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          value: Json_decode.optional((function (param) {
                  return Json_decode.field("value", Json_decode.string, param);
                }), json),
          domains: Json_decode.field("domains", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "domains",
                  Json_encode.list((function (prim) {
                          return prim;
                        }), t.domains)
                ],
                tl: /* [] */0
              }
            });
}

var dataTypeName = "EmailType";

exports.empty = empty;
exports.dataTypeName = dataTypeName;
exports.id = id;
exports.value = value;
exports.domains = domains;
exports.setDomains = setDomains;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
